var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_704)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29163 5.83333C6.1313 5.83333 5.01851 6.29427 4.19803 7.11474C3.37756 7.93521 2.91663 9.04801 2.91663 10.2083V11.6667H32.0833V10.2083C32.0833 9.04801 31.6224 7.93521 30.8019 7.11474C29.9814 6.29427 28.8686 5.83333 27.7083 5.83333H7.29163ZM32.0833 14.5833H2.91663V24.7917C2.91663 25.952 3.37756 27.0648 4.19803 27.8853C5.01851 28.7057 6.1313 29.1667 7.29163 29.1667H27.7083C28.8686 29.1667 29.9814 28.7057 30.8019 27.8853C31.6224 27.0648 32.0833 25.952 32.0833 24.7917V14.5833ZM11.6666 21.875C11.6666 21.4882 11.8203 21.1173 12.0938 20.8438C12.3673 20.5703 12.7382 20.4167 13.125 20.4167H19.562L19.3856 20.2402C19.1119 19.9668 18.9581 19.5958 18.958 19.209C18.9579 18.8221 19.1114 18.451 19.3849 18.1774C19.6583 17.9038 20.0293 17.7499 20.4161 17.7498C20.803 17.7497 21.174 17.9032 21.4477 18.1767L24.1135 20.844C24.3869 21.1174 24.5405 21.4883 24.5405 21.875C24.5405 22.2617 24.3869 22.6326 24.1135 22.906L21.4477 25.5719C21.3131 25.7112 21.1522 25.8223 20.9743 25.8987C20.7964 25.9751 20.605 26.0153 20.4114 26.017C20.2177 26.0187 20.0257 25.9818 19.8465 25.9085C19.6673 25.8352 19.5044 25.7269 19.3675 25.59C19.2306 25.453 19.1223 25.2902 19.049 25.111C18.9756 24.9317 18.9387 24.7397 18.9404 24.5461C18.9421 24.3524 18.9823 24.1611 19.0588 23.9832C19.1352 23.8052 19.2463 23.6443 19.3856 23.5098L19.562 23.3333H13.125C12.7382 23.3333 12.3673 23.1797 12.0938 22.9062C11.8203 22.6327 11.6666 22.2618 11.6666 21.875Z",
    fill: "url(#paint0_linear_1_704)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_704",
    x1: 17.5,
    y1: 5.83333,
    x2: 17.5,
    y2: 29.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18ACFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardpay);
export default __webpack_public_path__ + "static/media/cardpay.62323ffb08d3f2f74c11839bd41e18fd.svg";
export { ForwardRef as ReactComponent };